// client/src/components/itensVenda/HistoricoEstoqueModal.js
import React, { useState } from 'react';
import { X, TrendingUp, TrendingDown, Loader2, PackageSearch } from 'lucide-react';
import { useMovimentacoesEstoque } from '../../hooks/useItensVenda';
import Pagination from '../common/Pagination';

// ✅ 'tipo' é o valor salvo no banco (ver server/models/MovimentacaoEstoque.js)
// — sem esse rótulo, a tabela mostraria os valores crus em inglês/snake_case.
const TIPO_LABEL = {
    venda: 'Venda',
    cancelamento_venda: 'Cancelamento de venda',
    pedido: 'Pedido',
    cancelamento_pedido: 'Cancelamento de pedido',
    ajuste_manual: 'Ajuste manual',
};

const formatDateTime = (dateString) => {
    if (!dateString) return '--';
    try {
        return new Date(dateString).toLocaleString('pt-BR', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
    } catch (e) {
        return '--';
    }
};

const itemsPerPage = 15;

const HistoricoEstoqueModal = ({ item, onClose }) => {
    const [currentPage, setCurrentPage] = useState(1);

    const { data, isLoading, isError, error } = useMovimentacoesEstoque(item?._id, {
        page: currentPage,
        limit: itemsPerPage,
    });

    const movimentacoes = data?.data || [];
    const totalCount = data?.totalCount || 0;

    if (!item) return null;

    return (
        <div className="drawer-overlay" onClick={onClose}>
            <div className="drawer-content" onClick={(e) => e.stopPropagation()}>
                <div className="drawer-handle" />
                <div className="drawer-body">
                    <div className="modal-header">
                        <h4 className="modal-title">
                            <PackageSearch size={18} className="icon" />
                            Histórico de Estoque
                        </h4>
                        <button type="button" onClick={onClose} className="form-close-button">
                            <X size={22} />
                        </button>
                    </div>
                    <p className="modal-subtitle" style={{ marginBottom: 16 }}>{item.nome}</p>

                    {isLoading ? (
                        <div className="table-loading-state">
                            <Loader2 size={24} className="animate-spin" />
                            <span>Carregando histórico...</span>
                        </div>
                    ) : isError ? (
                        <div className="alert alert-danger">
                            {error?.response?.data?.error || error?.message || 'Erro ao carregar histórico de estoque.'}
                        </div>
                    ) : movimentacoes.length === 0 ? (
                        <div className="table-empty-state">
                            <PackageSearch size={40} className="empty-icon" />
                            <h3>Nenhuma movimentação registrada</h3>
                            <p>Vendas, pedidos e ajustes manuais de estoque deste produto aparecem aqui.</p>
                        </div>
                    ) : (
                        <>
                            <div className="table-container" style={{ margin: 0 }}>
                                <div className="table-wrapper">
                                    <table className="styled-table">
                                        <thead>
                                            <tr>
                                                <th>Data</th>
                                                <th>Tipo</th>
                                                <th>Unidade</th>
                                                <th className="text-center">Qtd.</th>
                                                <th className="text-center">Saldo após</th>
                                                <th>Responsável</th>
                                                <th>Motivo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {movimentacoes.map((mov) => (
                                                <tr key={mov._id}>
                                                    <td>{formatDateTime(mov.createdAt)}</td>
                                                    <td>{TIPO_LABEL[mov.tipo] || mov.tipo}</td>
                                                    <td>{mov.unidade?.nome || '--'}</td>
                                                    <td className="text-center">
                                                        <span
                                                            style={{
                                                                display: 'inline-flex', alignItems: 'center', gap: 4,
                                                                color: mov.quantidade >= 0 ? 'var(--color-success, #059669)' : 'var(--color-danger, #DC2626)',
                                                                fontWeight: 600
                                                            }}
                                                        >
                                                            {mov.quantidade >= 0
                                                                ? <TrendingUp size={14} />
                                                                : <TrendingDown size={14} />}
                                                            {mov.quantidade > 0 ? `+${mov.quantidade}` : mov.quantidade}
                                                        </span>
                                                    </td>
                                                    <td className="text-center">{mov.quantidadeApos}</td>
                                                    <td>{mov.criadoPor?.name || '--'}</td>
                                                    <td>{mov.motivo || '--'}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <Pagination
                                    itemsPerPage={itemsPerPage}
                                    totalItems={totalCount}
                                    onPageChange={setCurrentPage}
                                    currentPage={currentPage}
                                />
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default HistoricoEstoqueModal;
